exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.set-password-btn[data-v-0f049912] {\n  margin-left: 0;\n  margin-top: 20px;\n}\n", ""]);

